import api from "../http-request";

// [GET METHOD]
export const getListMunicipalitiesApi = async () =>
  api.get(`api/municipalitie/list`);
export const getListMunicipalitiesSearchApi = async (params) =>
  api.get(`api/municipalitie/list`, { params });
export const getDetailMunicipalitiesApi = async (id) =>
  api.get(`api/municipalitie/detail/${id}`);

export const getListLocation = async () => api.get(`api/admin/location/list`);
export const getListLocationSearchApi = async (params) =>
  api.get(`api/admin/location/list`, { params });

export const getDetailLocationApi = async (id) =>
  api.get(`api/admin/location/detail/${id}`);

export const getListPlanApi = async () => api.get(`api/plan/list`);
export const getListPlaneSearchApi = async (params) =>
  api.get(`api/plan/list`, { params });
export const getDetailPlanApi = async (id) => api.get(`api/plan/detail/${id}`);

export const getListTagsApi = async () => api.get(`api/tag/list`);
export const getListTagSearchApi = async (params) =>
  api.get(`api/tag/list`, { params });
export const getDetailTagsApi = async (id) => api.get(`api/tag/detail/${id}`);

// [POST METHOD]
export const createLocationApi = async (data) =>
  api.post(`api/admin/location/create`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const createMunicipalitiesApi = async (data) =>
  api.post(`api/admin/municipalitie/create`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const createTagsApi = async (data) =>
  api.post(`api/admin/tag/create`, data);
export const createSpacePlanApi = async (data) =>
  api.post(`api/admin/plan/create`, data);

// [DELETE METHOD]
export const deleteLocationApi = async (id) =>
  api.delete(`api/admin/location/delete/${id}`);
export const deleteMunicipalitiesApi = async (id) =>
  api.delete(`api/admin/municipalitie/delete/${id}`);
export const deleteTagsApi = async (id) =>
  api.delete(`api/admin/tag/delete/${id}`);
export const deletePlanApi = async (id) =>
  api.delete(`api/admin/plan/delete/${id}`);

// [PUT METHOD]
export const updateLocationApi = async (id, data) =>
  api.post(`api/admin/location/update/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const updateMunicipalitiesApi = async (id, data) =>
  api.post(`api/admin/municipalitie/update/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const updateTagsApi = async (id, data) =>
  api.put(`api/admin/tag/update/${id}`, data);
export const updatePlanApi = async (id, data) =>
  api.put(`api/admin/plan/update/${id}`, data);
